// Small DOM helpers shared by the desktop toolbars.

// Collapse runs of separators that have become adjacent because the group(s)
// between them are hidden. A `.sep` child is shown only when some visible
// non-separator content precedes it since the last shown separator; leading and
// trailing separators are hidden too. Call this after each render (or any time a
// section's visibility changes) so a hidden contextual group never leaves two
// divider lines stacked on top of each other.
export function tidySeparators(root: HTMLElement): void {
  let pendingGap = true; // list start behaves like a separator already stands here
  let lastShownSep: HTMLElement | null = null;
  for (const child of Array.from(root.children) as HTMLElement[]) {
    if (child.classList.contains("sep")) {
      if (pendingGap) {
        child.style.display = "none"; // redundant — nothing visible since the last gap
      } else {
        child.style.display = "";
        pendingGap = true;
        lastShownSep = child;
      }
      continue;
    }
    if (isVisible(child)) {
      pendingGap = false;
      lastShownSep = null;
    }
  }
  if (lastShownSep) lastShownSep.style.display = "none"; // trailing separator
}

function isVisible(el: HTMLElement): boolean {
  return !el.classList.contains("hidden") && el.style.display !== "none";
}
